import { render, staticRenderFns } from "./NavigationCard.vue?vue&type=template&id=390db745&scoped=true&"
import script from "./NavigationCard.vue?vue&type=script&lang=js&"
export * from "./NavigationCard.vue?vue&type=script&lang=js&"
import style0 from "./NavigationCard.vue?vue&type=style&index=0&id=390db745&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390db745",
  null
  
)

export default component.exports